// src/features/notifications-fnct/ActeurNotifications.tsx — SCE Issues
// Monté une fois (App.tsx, après « Qui utilise la tablette ? ») : dit aux
// notifications des FNC-T (api/notificationsFnct.api) qui agit dans cet onglet,
// pour ne pas se prévenir soi-même et pour signer « Répondre à ».
//
// Le compte RÉEL (`identiteDuCompte` : compte secondaire et tablette partagée
// compris), jamais la personne affichée en bascule de rôle — c'est lui qui écrit.

import { useEffect } from 'react'
import { useAuth } from '@/auth/useAuth'
import { identiteDuCompte } from '@/auth/identiteCompte'
import { definirActeurNotifications } from '@/api/notificationsFnct.api'
import { nomComplet } from '@/utils/noms'

export function ActeurNotifications(): null {
  const { account } = useAuth()
  const identite = identiteDuCompte(account)
  const upn = identite?.upn ?? ''
  const nom = identite ? nomComplet(identite.nomBrut, identite.upn) : ''

  useEffect(() => {
    definirActeurNotifications(upn ? { nom, upn } : null, window.location.origin)
    return () => definirActeurNotifications(null, window.location.origin)
  }, [upn, nom])

  return null
}
